module.exports = __webpack_public_path__ + "img/features_scorebuilder_phone.39e55ba9.jpg";